// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { Panel } from "../../components/ui/dashboard";

// type Mode = "add" | "list" | "edit";

// interface Props {
//   mode: Mode;
// }

// const AdminTransporterPage: React.FC<Props> = ({ mode }) => {
//   const apiUrl = process.env.REACT_APP_API_URL;
//   const navigate = useNavigate();
//   const params = useParams();
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState<string | null>(null);

//   // List state for drivers and vehicles (untouched for list ui)
//   const [allDrivers, setAllDrivers] = useState<any[]>([]);
//   const [allVehicles, setAllVehicles] = useState<any[]>([]);
//   const [tab, setTab] = useState<"vehicles" | "drivers">("vehicles");

//   // --- Edit-specific state, always declared (even if not used outside edit mode) ---
//   const [form, setForm] = useState<any>(null);
//   const [submitting, setSubmitting] = useState(false);
//   const [delLoading, setDelLoading] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);

//   // Editing helpers, always declared
//   const path = window.location.pathname;
//   const isDriver = path.includes("/admin/drivers/edit/");
//   const isVehicle = path.includes("/admin/vehicles/edit/");
//   const id = params.id || (path.match(/\/edit\/(\d+)/) ? path.match(/\/edit\/(\d+)/)![1] : null);

//   // Only fetch list in list mode - do NOT touch as per instructions
//   useEffect(() => {
//     if (!apiUrl || mode !== "list") return;
//     setLoading(true);
//     Promise.all([
//       fetch(`${apiUrl}/auth/drivers`).then((r) => r.json()).catch(() => []),
//       fetch(`${apiUrl}/auth/vehicles`).then((r) => r.json()).catch(() => [])
//     ]).then(([drivers, vehicles]) => {
//       setAllDrivers(Array.isArray(drivers) ? drivers : []);
//       setAllVehicles(Array.isArray(vehicles) ? vehicles : []);
//     }).finally(() => setLoading(false));
//   }, [mode, apiUrl]);

//   // Handlers for edit/delete in list UI (untouched per instruction)
//   const handleEditDriver = (driver: any) => {
//     navigate(`/admin/drivers/edit/${driver.id}`);
//   };
//   const handleEditVehicle = (vehicle: any) => {
//     navigate(`/admin/vehicles/edit/${vehicle.id}`);
//   };
//   const handleDeleteDriver = async (driverId: number) => {
//     if (!apiUrl) return;
//     if (!window.confirm("Are you sure you want to delete this driver?")) return;
//     setLoading(true);
//     setMessage(null);
//     try {
//       const res = await fetch(`${apiUrl}/auth/drivers/${driverId}`, { method: "DELETE" });
//       if (!res.ok) throw new Error("Failed to delete driver");
//       setAllDrivers((old) => old.filter((d) => d.id !== driverId));
//       setMessage("Driver deleted");
//     } catch (e: any) {
//       setMessage(e?.message || "Failed to delete driver");
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handleDeleteVehicle = async (vehicleId: number) => {
//     if (!apiUrl) return;
//     if (!window.confirm("Are you sure you want to delete this vehicle?")) return;
//     setLoading(true);
//     setMessage(null);
//     try {
//       const res = await fetch(`${apiUrl}/auth/vehicles/${vehicleId}`, { method: "DELETE" });
//       if (!res.ok) throw new Error("Failed to delete vehicle");
//       setAllVehicles((old) => old.filter((v) => v.id !== vehicleId));
//       setMessage("Vehicle deleted");
//     } catch (e: any) {
//       setMessage(e?.message || "Failed to delete vehicle");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // --- EDIT API + Modal Design ---
//   useEffect(() => {
//     if (mode !== "edit" || !apiUrl || !id) return;
//     setShowEditModal(true);
//     setLoading(true);
//     setMessage(null);
//     // Use our own API endpoints for edit - e.g., /api/our-drivers/:id or /api/our-vehicles/:id
//     let fetchUrl: null | string = null;
//     if (isDriver) {
//       fetchUrl = `${apiUrl}/api/our-drivers/${id}`;
//     } else if (isVehicle) {
//       fetchUrl = `${apiUrl}/api/our-vehicles/${id}`;
//     }
//     if (!fetchUrl) {
//       setLoading(false);
//       setMessage("No fetch URL available");
//       return;
//     }
//     fetch(fetchUrl)
//       .then((r) => {
//         if (!r.ok) throw new Error("Failed to fetch details");
//         return r.json();
//       })
//       .then((data) => setForm(data))
//       .catch((e) => setMessage(e?.message || "Failed to fetch details"))
//       .finally(() => setLoading(false));
//     // eslint-disable-next-line
//   }, [mode, apiUrl, id, isDriver, isVehicle]);

//   // Input change always declared
//   const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
//     setForm((old: any) => ({
//       ...old,
//       [e.target.name]: e.target.value
//     }));
//   };

//   // Save handler to use our API and modal
//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!form || !id || !apiUrl) return;
//     setSubmitting(true);
//     setMessage(null);
//     try {
//       // Set correct URL for edit
//       let res: Response;
//       if (isDriver) {
//         // /api/our-drivers/:id (PUT)
//         res = await fetch(`${apiUrl}/api/our-drivers/${id}`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         });
//       } else if (isVehicle) {
//         // /api/our-vehicles/:id (PUT)
//         res = await fetch(`${apiUrl}/api/our-vehicles/${id}`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         });
//       } else {
//         throw new Error("Unknown edit type");
//       }
//       if (!res.ok) throw new Error("Failed to update");
//       setMessage("Saved successfully!");
//       setTimeout(() => {
//         setShowEditModal(false);
//         if (isDriver) {
//           navigate("/admin/transporters?tab=drivers");
//         } else if (isVehicle) {
//           navigate("/admin/transporters?tab=vehicles");
//         } else {
//           navigate("/admin/transporters");
//         }
//       }, 600);
//     } catch (e: any) {
//       setMessage(e?.message || "Update failed");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // Delete handler with our API
//   const handleDelete = async () => {
//     if (!id || !apiUrl) return;
//     if (!window.confirm(`Are you sure you want to delete this ${isDriver ? "driver" : "vehicle"}?`)) return;
//     setDelLoading(true);
//     setMessage(null);
//     try {
//       let res: Response;
//       if (isDriver) {
//         res = await fetch(`${apiUrl}/api/our-drivers/${id}`, { method: "DELETE" });
//       } else if (isVehicle) {
//         res = await fetch(`${apiUrl}/api/our-vehicles/${id}`, { method: "DELETE" });
//       } else {
//         throw new Error("Unknown delete type");
//       }
//       if (!res.ok) throw new Error("Failed to delete");
//       setMessage(`${isDriver ? "Driver" : "Vehicle"} deleted`);
//       setTimeout(() => {
//         setShowEditModal(false);
//         navigate("/admin/transporters?tab=" + (isDriver ? "drivers" : "vehicles"));
//       }, 300);
//     } catch (e: any) {
//       setMessage(e?.message || "Failed to delete");
//     } finally {
//       setDelLoading(false);
//     }
//   };

//   // Modal Design for Edit
//   const EditModal = () =>
//     <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/30">
//       <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg relative">
//         <button
//           type="button"
//           onClick={() => {
//             setShowEditModal(false);
//             navigate(-1);
//           }}
//           className="absolute top-3 right-3 text-gray-400 hover:text-gray-900 text-2xl"
//           title="Close"
//           aria-label="Close Modal"
//         >&times;</button>
//         <Panel
//           title={isDriver ? `Edit Driver` : `Edit Vehicle`}
//           subtitle={isDriver ? `Driver ID: ${id}` : `Vehicle ID: ${id}`}
//         >
//           {loading ? (
//             <div className="py-8 text-center text-slate-500">Loading…</div>
//           ) : !form ? (
//             <div className="py-8 text-center text-slate-400">
//               {message || "Loading form..."}
//             </div>
//           ) : (
//             <form onSubmit={handleSubmit} className="space-y-4">
//               {isDriver ? (
//                 <>
//                   <div>
//                     <label className="block font-semibold text-xs mb-1">Name</label>
//                     <input
//                       required
//                       name="name"
//                       type="text"
//                       value={form.name ?? ""}
//                       onChange={handleChange}
//                       className="input w-full"
//                     />
//                   </div>
//                   <div>
//                     <label className="block font-semibold text-xs mb-1">Phone</label>
//                     <input
//                       required
//                       name="phone"
//                       type="text"
//                       value={form.phone ?? ""}
//                       onChange={handleChange}
//                       className="input w-full"
//                     />
//                   </div>
//                   <div>
//                     <label className="block font-semibold text-xs mb-1">License Number</label>
//                     <input
//                       name="license_number"
//                       type="text"
//                       value={form.license_number ?? ""}
//                       onChange={handleChange}
//                       className="input w-full"
//                     />
//                   </div>
//                   <div>
//                     <label className="block font-semibold text-xs mb-1">License Expiry</label>
//                     <input
//                       name="license_expiry"
//                       type="date"
//                       value={form.license_expiry ? form.license_expiry.slice(0, 10) : ""}
//                       onChange={handleChange}
//                       className="input w-full"
//                     />
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   <div>
//                     <label className="block font-semibold text-xs mb-1">Registration Number</label>
//                     <input
//                       required
//                       name="registration_number"
//                       type="text"
//                       value={form.registration_number ?? ""}
//                       onChange={handleChange}
//                       className="input w-full"
//                     />
//                   </div>
//                   <div>
//                     <label className="block font-semibold text-xs mb-1">Vehicle Type</label>
//                     <input
//                       name="vehicle_type"
//                       type="text"
//                       value={form.vehicle_type ?? ""}
//                       onChange={handleChange}
//                       className="input w-full"
//                     />
//                   </div>
//                   <div>
//                     <label className="block font-semibold text-xs mb-1">Capacity (kg)</label>
//                     <input
//                       name="capacity_kg"
//                       type="number"
//                       value={form.capacity_kg ?? ""}
//                       onChange={handleChange}
//                       className="input w-full"
//                     />
//                   </div>
//                   <div>
//                     <label className="block font-semibold text-xs mb-1">Color</label>
//                     <input
//                       name="color"
//                       type="text"
//                       value={form.color ?? ""}
//                       onChange={handleChange}
//                       className="input w-full"
//                     />
//                   </div>
//                 </>
//               )}
//               <div className="flex items-center gap-4 mt-4">
//                 <button
//                   type="submit"
//                   className="bg-indigo-600 text-white px-6 py-2 rounded font-semibold"
//                   disabled={submitting}
//                 >
//                   {submitting ? "Saving..." : "Save"}
//                 </button>
//                 <button
//                   type="button"
//                   className="bg-red-600 text-white px-4 py-2 rounded font-semibold"
//                   onClick={handleDelete}
//                   disabled={delLoading}
//                 >
//                   {delLoading ? "Deleting..." : "Delete"}
//                 </button>
//               </div>
//               {message && <div className="mt-2 text-xs text-red-500">{message}</div>}
//             </form>
//           )}
//         </Panel>
//       </div>
//     </div>;

//   // --- UI sections ---

//   // Modal for "edit" mode using custom design
//   if (mode === "edit") {
//     return showEditModal ? <EditModal /> : null;
//   }

//   // Do not touch list UI, return as-is
//   if (mode === "list") {
//     return (
//       <div className="p-4 md:p-6">
//         <Panel title="All Vehicles & Drivers" subtitle="">
//           <div className="mb-3 flex gap-4 items-center">
//             <button
//               className={`px-4 py-2 text-sm font-semibold border-b-2 ${
//                 tab === "vehicles"
//                   ? "border-indigo-600 text-indigo-700"
//                   : "border-transparent text-slate-700"
//               }`}
//               onClick={() => setTab("vehicles")}
//               type="button"
//             >
//               Vehicles ({allVehicles.length})
//             </button>
//             <button
//               className={`px-4 py-2 text-sm font-semibold border-b-2 ${
//                 tab === "drivers"
//                   ? "border-indigo-600 text-indigo-700"
//                   : "border-transparent text-slate-700"
//               }`}
//               onClick={() => setTab("drivers")}
//               type="button"
//             >
//               Drivers ({allDrivers.length})
//             </button>
//             <div className="flex-1" />
//             {tab === "vehicles" ? (
//               <Link
//                 to="/admin/vehicles/add"
//                 className="px-3 py-2 rounded-lg text-sm bg-slate-900 text-white"
//               >
//                 Add Vehicle
//               </Link>
//             ) : (
//               <Link
//                 to="/admin/drivers/add"
//                 className="px-3 py-2 rounded-lg text-sm bg-slate-900 text-white"
//               >
//                 Add Driver
//               </Link>
//             )}
//           </div>

//           {tab === "vehicles" ? (
//             <div className="grid gap-1 mt-4">
//               <div className="grid grid-cols-5 font-semibold text-xs text-slate-500 py-2">
//                 <span>Registration No.</span>
//                 <span>Transporter</span>
//                 <span>User ID</span>
//                 <span></span>
//                 <span>Actions</span>
//               </div>
//               {allVehicles.length === 0 && (
//                 <p className="text-xs text-slate-500 px-2">No vehicles</p>
//               )}
//               {allVehicles.map((vehicle) => (
//                 <div
//                   key={vehicle.id}
//                   className="grid grid-cols-5 items-center border rounded p-2 bg-slate-50"
//                 >
//                   <span>{vehicle.registration_number ?? "-"}</span>
//                   <span>{vehicle.transporter?.company_name ?? "-"}</span>
//                   <span>{vehicle.transporter_id ?? "-"}</span>
//                   <span></span>
//                   <span className="flex gap-2">
//                     <button
//                       onClick={() => handleEditVehicle(vehicle)}
//                       className="px-2 py-1 text-xs rounded-md bg-yellow-100 text-yellow-700"
//                     >
//                       Edit
//                     </button>
//                     <button
//                       onClick={() => handleDeleteVehicle(vehicle.id)}
//                       className="px-2 py-1 text-xs rounded-md bg-red-100 text-red-700"
//                     >
//                       Delete
//                     </button>
//                   </span>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="grid gap-1 mt-4">
//               <div className="grid grid-cols-6 font-semibold text-xs text-slate-500 py-2">
//                 <span>Driver Name</span>
//                 <span>Driver Number</span>
//                 <span>Transporter</span>
//                 <span>User ID</span>
//                 <span></span>
//                 <span>Actions</span>
//               </div>
//               {allDrivers.length === 0 && (
//                 <p className="text-xs text-slate-500 px-2">No drivers</p>
//               )}
//               {allDrivers.map((driver) => (
//                 <div
//                   key={driver.id}
//                   className="grid grid-cols-6 items-center border rounded p-2 bg-slate-50"
//                 >
//                   <span>{driver.name ?? "-"}</span>
//                   <span>{driver.driver_number ?? "-"}</span>
//                   <span>{driver.transporter?.company_name ?? "-"}</span>
//                   <span>{driver.transporter_id ?? "-"}</span>
//                   <span></span>
//                   <span className="flex gap-2">
//                     <button
//                       onClick={() => handleEditDriver(driver)}
//                       className="px-2 py-1 text-xs rounded-md bg-yellow-100 text-yellow-700"
//                     >
//                       Edit
//                     </button>
//                     <button
//                       onClick={() => handleDeleteDriver(driver.id)}
//                       className="px-2 py-1 text-xs rounded-md bg-red-100 text-red-700"
//                     >
//                       Delete
//                     </button>
//                   </span>
//                 </div>
//               ))}
//             </div>
//           )}
//           {message && <div className="mt-2 text-xs text-red-500">{message}</div>}
//         </Panel>
//       </div>
//     );
//   }

//   // For add or other invalid modes, show nothing
//   return null;
// };

// export default AdminTransporterPage;
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { Panel } from "../../components/ui/dashboard";

// // Types
// type Mode = "add" | "list" | "edit";
// interface Props {
//   mode: Mode;
// }

// // Utils
// function stripDateOnly(val: string | undefined | null) {
//   if (!val) return "";
//   return val.split("T")[0] || val;
// }
// function prepareUpdatePayload(form: any, type: "driver" | "vehicle" | null) {
//   if (!form || typeof form !== "object") return form;
//   const updated = { ...form };
//   for (const key of Object.keys(updated)) {
//     if (
//       typeof updated[key] === "string" &&
//       (
//         key.toLowerCase().includes("date") ||
//         key.toLowerCase().includes("expiry") ||
//         key.toLowerCase().includes("dob")
//       )
//     ) {
//       updated[key] = stripDateOnly(updated[key]);
//     }
//   }
//   return updated;
// }

// const DRIVER_FIELDS = [
//   { name: "name", label: "Name", required: true, type: "text" },
//   { name: "phone", label: "Phone", required: false, type: "text" },
//   { name: "license_number", label: "License Number", required: false, type: "text" },
//   { name: "license_expiry", label: "License Expiry", required: false, type: "date" },
// ];

// const VEHICLE_FIELDS = [
//   { name: "vehicle_number", label: "Vehicle Number", required: true, type: "text" },
//   { name: "vehicle_type", label: "Vehicle Type", required: false, type: "text" },
//   { name: "capacity_kg", label: "Capacity (kg)", required: false, type: "number" },
//   { name: "color", label: "Color", required: false, type: "text" },
//   { name: "fitness_expiry", label: "Fitness Expiry", required: false, type: "date" },
// ];

// // Modal Form (used for both add and edit, perfect modalized experience)
// function ModalForm({
//   show,
//   type,
//   form,
//   onClose,
//   onChange,
//   onSubmit,
//   onDelete,
//   submitting,
//   delLoading,
//   message,
//   isEdit,
//   title,
//   subtitle,
// }: {
//   show: boolean,
//   type: "driver" | "vehicle" | null,
//   form: any,
//   onClose: () => void,
//   onChange: (e: React.ChangeEvent<any>) => void,
//   onSubmit: (e: React.FormEvent) => void,
//   onDelete?: () => void,
//   submitting: boolean,
//   delLoading: boolean,
//   message: string | null,
//   isEdit: boolean,
//   title?: string,
//   subtitle?: string,
// }) {
//   if (!show || !type) return null;
//   const fields = type === "driver" ? DRIVER_FIELDS : VEHICLE_FIELDS;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
//       <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg relative">
//         <button
//           type="button"
//           onClick={onClose}
//           className="absolute top-3 right-3 text-gray-400 hover:text-gray-900 text-2xl"
//           title="Close"
//           aria-label="Close Modal"
//         >
//           &times;
//         </button>
//         <Panel title={title || (isEdit ? `Edit ${type[0].toUpperCase() + type.slice(1)}` : `Add ${type[0].toUpperCase() + type.slice(1)}`)} subtitle={subtitle}>
//           {!form ? (
//             <div className="py-8 text-center text-slate-500">
//               Loading…
//             </div>
//           ) : (
//             <form onSubmit={onSubmit} className="space-y-4">
//               {fields.map(field => (
//                 <div key={field.name}>
//                   <label className="block font-semibold text-xs mb-1">{field.label}{field.required ? " *" : ""}</label>
//                   <input
//                     name={field.name}
//                     type={field.type}
//                     required={field.required}
//                     value={
//                       field.type === "date"
//                         ? (form[field.name] ? stripDateOnly(form[field.name]) : "")
//                         : (form[field.name] ?? "")
//                     }
//                     onChange={onChange}
//                     className="input w-full"
//                   />
//                 </div>
//               ))}
//               <div className="flex items-center gap-4 mt-4">
//                 <button type="submit" className="bg-indigo-600 text-white px-6 py-2 rounded font-semibold" disabled={submitting}>
//                   {submitting ? "Saving..." : "Save"}
//                 </button>
//                 {isEdit && onDelete && (
//                   <button type="button" className="bg-red-600 text-white px-4 py-2 rounded font-semibold" onClick={onDelete} disabled={delLoading}>
//                     {delLoading ? "Deleting..." : "Delete"}
//                   </button>
//                 )}
//               </div>
//               {message && <div className={`mt-2 text-xs ${/success|deleted/i.test(message) ? "text-green-600" : "text-red-500"}`}>{message}</div>}
//             </form>
//           )}
//         </Panel>
//       </div>
//     </div>
//   );
// }

// const AdminTransporterPage: React.FC<Props> = ({ mode }) => {
//   const apiUrl = process.env.REACT_APP_API_URL;
//   const navigate = useNavigate();
//   const params = useParams();

//   // --- List state ---
//   const [allDrivers, setAllDrivers] = useState<any[]>([]);
//   const [allVehicles, setAllVehicles] = useState<any[]>([]);
//   const [tab, setTab] = useState<"vehicles" | "drivers">("vehicles");
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState<string | null>(null);

//   // --- Modal state (add/update perfect modal) ---
//   // "modalMode": "add" or "edit" or null, and type: driver or vehicle
//   const [modalMode, setModalMode] = useState<"add" | "edit" | null>(null);
//   const [modalType, setModalType] = useState<"driver" | "vehicle" | null>(null);
//   const [modalForm, setModalForm] = useState<any>(null);
//   const [modalSubmitting, setModalSubmitting] = useState(false);
//   const [modalDelLoading, setModalDelLoading] = useState(false);
//   const [modalMessage, setModalMessage] = useState<string | null>(null);
//   const [modalId, setModalId] = useState<string | null>(null);

//   // Modal open helpers
//   const openAddModal = (type: "driver" | "vehicle") => {
//     setModalMode("add");
//     setModalType(type);
//     setModalForm({}); // Blank form
//     setModalSubmitting(false);
//     setModalDelLoading(false);
//     setModalMessage(null);
//     setModalId(null);
//   };

//   const openEditModal = (type: "driver" | "vehicle", recordId: number) => {
//     setModalMode("edit");
//     setModalType(type);
//     setModalSubmitting(false);
//     setModalDelLoading(false);
//     setModalMessage(null);
//     setModalId(String(recordId));
//     setModalForm(null);
//     setLoading(true);
//     const url =
//       type === "driver"
//         ? `${apiUrl}/auth/drivers/${recordId}`
//         : `${apiUrl}/auth/vehicles/${recordId}`;
//     fetch(url)
//       .then((r) => {
//         if (!r.ok) throw new Error("Failed to fetch details");
//         return r.json();
//       })
//       .then((data) => setModalForm(data))
//       .catch((e) => setModalMessage(e?.message || "Failed to fetch details"))
//       .finally(() => setLoading(false));
//   };

//   const closeModal = () => {
//     setModalMode(null);
//     setModalType(null);
//     setModalForm(null);
//     setModalMessage(null);
//     setModalSubmitting(false);
//     setModalDelLoading(false);
//     setModalId(null);
//   };

//   // On open edit from list
//   const handleEditDriver = (driver: any) => openEditModal("driver", driver.id);
//   const handleEditVehicle = (vehicle: any) => openEditModal("vehicle", vehicle.id);

//   // On open add from UI
//   const handleAddDriver = () => openAddModal("driver");
//   const handleAddVehicle = () => openAddModal("vehicle");

//   // Modal input
//   const handleModalChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
//     setModalForm((old: any) => ({ ...old, [e.target.name]: e.target.value }));
//   };

//   // Modal submit: Add or Edit
//   const handleModalSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!modalForm || !modalType || !apiUrl) return;
//     setModalSubmitting(true);
//     setModalMessage(null);

//     try {
//       let url = "";
//       let method: "POST" | "PUT" = "POST";
//       let res: Response;
//       let payload = prepareUpdatePayload(modalForm, modalType);
//       let isEdit = modalMode === "edit" && modalId;

//       if (modalType === "driver") {
//         if (isEdit) {
//           method = "PUT";
//           url = `${apiUrl}/auth/drivers/${modalId}`;
//         } else {
//           url = `${apiUrl}/auth/drivers`;
//         }
//       } else {
//         if (isEdit) {
//           method = "PUT";
//           url = `${apiUrl}/auth/vehicles/${modalId}`;
//         } else {
//           url = `${apiUrl}/auth/vehicles`;
//         }
//       }

//       res = await fetch(url, {
//         method,
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       if (!res.ok) throw new Error(isEdit ? "Failed to update" : "Failed to add");

//       const resultData = await res.json();

//       // If in ADD mode and successful, reload the whole page (list)
//       if (!isEdit && (mode === "add" || mode === "list")) {
//         window.location.reload();
//         return;
//       }
//       // If in EDIT mode and successful, reload the page (edit detail)
//       if (isEdit && mode === "edit") {
//         window.location.reload();
//         return;
//       }

//       if (modalType === "driver") {
//         if (isEdit) {
//           setAllDrivers((old) => old.map((d) => String(d.id) === modalId ? { ...d, ...payload } : d));
//           setModalMessage("Saved successfully!");
//         } else {
//           setAllDrivers((old) => [...old, resultData]);
//           setModalMessage("Driver added successfully!");
//         }
//       } else {
//         if (isEdit) {
//           setAllVehicles((old) => old.map((v) => String(v.id) === modalId ? { ...v, ...payload } : v));
//           setModalMessage("Saved successfully!");
//         } else {
//           setAllVehicles((old) => [...old, resultData]);
//           setModalMessage("Vehicle added successfully!");
//         }
//       }
//       setTimeout(closeModal, 700);
//     } catch (e: any) {
//       setModalMessage(e?.message || (modalMode === "edit" ? "Update failed" : "Add failed"));
//     } finally {
//       setModalSubmitting(false);
//     }
//   };

//   // Delete from modal (edit mode)
//   const handleModalDelete = async () => {
//     if (!modalType || !modalId || !apiUrl) return;
//     if (
//       !window.confirm(`Are you sure you want to delete this ${modalType}?`)
//     ) return;
//     setModalDelLoading(true);
//     setModalMessage(null);

//     try {
//       let url =
//         modalType === "driver"
//         ? `${apiUrl}/auth/drivers/${modalId}`
//         : `${apiUrl}/auth/vehicles/${modalId}`;
//       let res = await fetch(url, { method: "DELETE" });
//       if (!res.ok) throw new Error(`Failed to delete`);
//       if (modalType === "driver") {
//         setAllDrivers((old) => old.filter((d) => String(d.id) !== modalId));
//       } else {
//         setAllVehicles((old) => old.filter((v) => String(v.id) !== modalId));
//       }
//       setModalMessage(`${modalType[0].toUpperCase() + modalType.slice(1)} deleted`);
//       setTimeout(closeModal, 500);
//     } catch (e: any) {
//       setModalMessage(e?.message || "Failed to delete");
//     } finally {
//       setModalDelLoading(false);
//     }
//   };

//   // Delete from list (not modal)
//   const handleDeleteDriver = async (driverId: number) => {
//     if (!apiUrl) return;
//     if (!window.confirm("Are you sure you want to delete this driver?")) return;
//     setLoading(true);
//     setMessage(null);
//     try {
//       const res = await fetch(`${apiUrl}/auth/drivers/${driverId}`, { method: "DELETE" });
//       if (!res.ok) throw new Error("Failed to delete driver");
//       setAllDrivers((old) => old.filter((d) => d.id !== driverId));
//       setMessage("Driver deleted");
//     } catch (e: any) {
//       setMessage(e?.message || "Failed to delete driver");
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handleDeleteVehicle = async (vehicleId: number) => {
//     if (!apiUrl) return;
//     if (!window.confirm("Are you sure you want to delete this vehicle?")) return;
//     setLoading(true);
//     setMessage(null);
//     try {
//       const res = await fetch(`${apiUrl}/auth/vehicles/${vehicleId}`, { method: "DELETE" });
//       if (!res.ok) throw new Error("Failed to delete vehicle");
//       setAllVehicles((old) => old.filter((v) => v.id !== vehicleId));
//       setMessage("Vehicle deleted");
//     } catch (e: any) {
//       setMessage(e?.message || "Failed to delete vehicle");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // List loading
//   useEffect(() => {
//     if (!apiUrl || mode !== "list") return;
//     setLoading(true);
//     Promise.all([
//       fetch(`${apiUrl}/auth/drivers`).then((r) => r.json()).catch(() => []),
//       fetch(`${apiUrl}/auth/vehicles`).then((r) => r.json()).catch(() => [])
//     ]).then(([drivers, vehicles]) => {
//       setAllDrivers(Array.isArray(drivers) ? drivers : []);
//       setAllVehicles(Array.isArray(vehicles) ? vehicles : []);
//     }).finally(() => setLoading(false));
//   }, [mode, apiUrl]);

//   // For "edit" mode via route (modal covering the whole page)
//   const path = window.location.pathname;
//   const isDriver = path.includes("/admin/drivers/edit/");
//   const isVehicle = path.includes("/admin/vehicles/edit/");
//   const id = params.id || (path.match(/\/edit\/(\d+)/) ? path.match(/\/edit\/(\d+)/)![1] : null);

//   // For route edit modal (show full overlay)
//   const [routeEditForm, setRouteEditForm] = useState<any>(null);
//   const [routeEditLoading, setRouteEditLoading] = useState(false);
//   const [routeEditMessage, setRouteEditMessage] = useState<string | null>(null);
//   const [showRouteEditModal, setShowRouteEditModal] = useState(false);
//   const [routeEditSubmitting, setRouteEditSubmitting] = useState(false);
//   const [routeEditDelLoading, setRouteEditDelLoading] = useState(false);

//   useEffect(() => {
//     if (mode !== "edit" || !apiUrl || !id) return;
//     setShowRouteEditModal(true);
//     setRouteEditLoading(true);
//     setRouteEditForm(null);
//     setRouteEditMessage(null);
//     let fetchUrl: null | string = null;
//     if (isDriver) {
//       fetchUrl = `${apiUrl}/auth/drivers/${id}`;
//     } else if (isVehicle) {
//       fetchUrl = `${apiUrl}/auth/vehicles/${id}`;
//     }
//     if (!fetchUrl) {
//       setRouteEditLoading(false);
//       setRouteEditMessage("No fetch URL available");
//       return;
//     }
//     fetch(fetchUrl)
//       .then((r) => {
//         if (!r.ok) throw new Error("Failed to fetch details");
//         return r.json();
//       })
//       .then((data) => setRouteEditForm(data))
//       .catch((e) => setRouteEditMessage(e?.message || "Failed to fetch details"))
//       .finally(() => setRouteEditLoading(false));
//     // eslint-disable-next-line
//   }, [mode, apiUrl, id, isDriver, isVehicle]);

//   // For route mode input + submit + delete
//   const handleRouteEditChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
//     setRouteEditForm((old: any) => ({ ...old, [e.target.name]: e.target.value }));
//   };
//   const handleRouteEditSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!routeEditForm || !id || !apiUrl) return;
//     setRouteEditSubmitting(true);
//     setRouteEditMessage(null);
//     try {
//       let payload: any = routeEditForm;
//       let res: Response;
//       if (isDriver) {
//         payload = prepareUpdatePayload(routeEditForm, "driver");
//         res = await fetch(`${apiUrl}/auth/drivers/${id}`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });
//       } else if (isVehicle) {
//         payload = prepareUpdatePayload(routeEditForm, "vehicle");
//         res = await fetch(`${apiUrl}/auth/vehicles/${id}`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });
//       } else throw new Error("Unknown edit type");
//       if (!res.ok) throw new Error("Failed to update");
//       // After successful update in edit mode via route, reload the page
//       window.location.reload();
//       return;
//     } catch (e: any) {
//       setRouteEditMessage(e?.message || "Update failed");
//     } finally {
//       setRouteEditSubmitting(false);
//     }
//   };
//   const handleRouteEditDelete = async () => {
//     if (!id || !apiUrl) return;
//     if (
//       !window.confirm(
//         `Are you sure you want to delete this ${isDriver ? "driver" : "vehicle"}?`
//       )
//     ) return;
//     setRouteEditDelLoading(true);
//     setRouteEditMessage(null);
//     try {
//       let res: Response;
//       if (isDriver) {
//         res = await fetch(`${apiUrl}/auth/drivers/${id}`, { method: "DELETE" });
//       } else if (isVehicle) {
//         res = await fetch(`${apiUrl}/auth/vehicles/${id}`, { method: "DELETE" });
//       } else throw new Error("Unknown delete type");
//       if (!res.ok) throw new Error("Failed to delete");
//       setRouteEditMessage(`${isDriver ? "Driver" : "Vehicle"} deleted`);
//       setTimeout(() => {
//         setShowRouteEditModal(false);
//         navigate("/admin/transporters?tab=" + (isDriver ? "drivers" : "vehicles"));
//       }, 300);
//     } catch (e: any) {
//       setRouteEditMessage(e?.message || "Failed to delete");
//     } finally {
//       setRouteEditDelLoading(false);
//     }
//   };

//   // --- UI ---

//   // 1. Modal for Add/Edit ("perfect" modal handling for add & update)
//   const showModal = !!modalMode;
//   const showPerfectModal = showModal && modalType != null;

//   // 2. Route-edit modal overlay (edit page)
//   if (mode === "edit") {
//     return showRouteEditModal ? (
//       <ModalForm
//         show={showRouteEditModal}
//         type={isDriver ? "driver" : "vehicle"}
//         form={routeEditForm}
//         onClose={() => { setShowRouteEditModal(false); navigate(-1); }}
//         onChange={handleRouteEditChange}
//         onSubmit={handleRouteEditSubmit}
//         onDelete={handleRouteEditDelete}
//         submitting={routeEditSubmitting}
//         delLoading={routeEditDelLoading}
//         message={routeEditMessage}
//         isEdit={true}
//         title={isDriver ? "Edit Driver" : "Edit Vehicle"}
//         subtitle={isDriver ? `Driver ID: ${id}` : `Vehicle ID: ${id}`}
//       />
//     ) : null;
//   }

//   // 3. List UI
//   if (mode === "list") {
//     return (
//       <div className="p-4 md:p-6">
//         {/* Perfect add/edit modal covering this page */}
//         {showPerfectModal &&
//           <ModalForm
//             show={showPerfectModal}
//             type={modalType}
//             form={modalForm}
//             onClose={closeModal}
//             onChange={handleModalChange}
//             onSubmit={handleModalSubmit}
//             onDelete={modalMode === "edit" ? handleModalDelete : undefined}
//             submitting={modalSubmitting}
//             delLoading={modalDelLoading}
//             message={modalMessage}
//             isEdit={modalMode === "edit"}
//             // title & subtitle auto
//           />
//         }

//         <Panel title="All Vehicles & Drivers" subtitle="">
//           <div className="mb-3 flex gap-4 items-center">
//             <button
//               className={`px-4 py-2 text-sm font-semibold border-b-2 ${
//                 tab === "vehicles"
//                   ? "border-indigo-600 text-indigo-700"
//                   : "border-transparent text-slate-700"
//               }`}
//               onClick={() => setTab("vehicles")}
//               type="button"
//             >
//               Vehicles ({allVehicles.length})
//             </button>
//             <button
//               className={`px-4 py-2 text-sm font-semibold border-b-2 ${
//                 tab === "drivers"
//                   ? "border-indigo-600 text-indigo-700"
//                   : "border-transparent text-slate-700"
//               }`}
//               onClick={() => setTab("drivers")}
//               type="button"
//             >
//               Drivers ({allDrivers.length})
//             </button>
//             <div className="flex-1" />
//             {tab === "vehicles" ? (
//               <button
//                 type="button"
//                 onClick={handleAddVehicle}
//                 className="px-3 py-2 rounded-lg text-sm bg-slate-900 text-white"
//               >
//                 Add Vehicle
//               </button>
//             ) : (
//               <button
//                 type="button"
//                 onClick={handleAddDriver}
//                 className="px-3 py-2 rounded-lg text-sm bg-slate-900 text-white"
//               >
//                 Add Driver
//               </button>
//             )}
//           </div>

//           {tab === "vehicles" ? (
//             <div className="grid gap-1 mt-4">
//               <div className="grid grid-cols-5 font-semibold text-xs text-slate-500 py-2">
//                 <span>Vehicle No.</span>
//                 <span></span>
//                 <span>Actions</span>
//               </div>
//               {allVehicles.length === 0 && (
//                 <p className="text-xs text-slate-500 px-2">No vehicles</p>
//               )}
//               {allVehicles.map((vehicle) => (
//                 <div key={vehicle.id} className="grid grid-cols-5 items-center border rounded p-2 bg-slate-50">
//                   <span>{vehicle.vehicle_number ?? "-"}</span>
//                   <span></span>
//                   <span className="flex gap-2">
//                     <button
//                       type="button"
//                       onClick={() => handleEditVehicle(vehicle)}
//                       className="px-2 py-1 text-xs rounded-md bg-yellow-100 text-yellow-700"
//                     >
//                       Edit
//                     </button>
//                     <button
//                       type="button"
//                       onClick={() => handleDeleteVehicle(vehicle.id)}
//                       className="px-2 py-1 text-xs rounded-md bg-red-100 text-red-700"
//                     >
//                       Delete
//                     </button>
//                   </span>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="grid gap-1 mt-4">
//               <div className="grid grid-cols-6 font-semibold text-xs text-slate-500 py-2">
//                 <span>Driver Name</span>
//                 <span>Driver Number</span>
               

//                 <span></span>
//                 <span>Actions</span>
//               </div>
//               {allDrivers.length === 0 && (
//                 <p className="text-xs text-slate-500 px-2">No drivers</p>
//               )}
//               {allDrivers.map((driver) => (
//                 <div key={driver.id} className="grid grid-cols-6 items-center border rounded p-2 bg-slate-50">
//                   <span>{driver.name ?? "-"}</span>
//                   <span>{driver.phone ?? "-"}</span>
                
             
//                   <span></span>
//                   <span className="flex gap-2">
//                     <button
//                       type="button"
//                       onClick={() => handleEditDriver(driver)}
//                       className="px-2 py-1 text-xs rounded-md bg-yellow-100 text-yellow-700"
//                     >
//                       Edit
//                     </button>
//                     <button
//                       type="button"
//                       onClick={() => handleDeleteDriver(driver.id)}
//                       className="px-2 py-1 text-xs rounded-md bg-red-100 text-red-700"
//                     >
//                       Delete
//                     </button>
//                   </span>
//                 </div>
//               ))}
//             </div>
//           )}
//           {message && <div className="mt-2 text-xs text-red-500">{message}</div>}
//         </Panel>
//       </div>
//     );
//   }

//   // Fallback
//   return null;
// };

// export default AdminTransporterPage;


import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Panel } from "../../components/ui/dashboard";

// Types
type Mode = "add" | "list" | "edit";
interface Props {
  mode: Mode;
}

// Utils
function stripDateOnly(val: string | undefined | null) {
  if (!val) return "";
  return val.split("T")[0] || val;
}
function prepareUpdatePayload(form: any, type: "driver" | "vehicle" | null) {
  if (!form || typeof form !== "object") return form;
  const updated = { ...form };
  for (const key of Object.keys(updated)) {
    if (
      typeof updated[key] === "string" &&
      (
        key.toLowerCase().includes("date") ||
        key.toLowerCase().includes("expiry") ||
        key.toLowerCase().includes("dob")
      )
    ) {
      updated[key] = stripDateOnly(updated[key]);
    }
  }
  return updated;
}

const DRIVER_FIELDS = [
  { name: "name", label: "Full Name", required: true, type: "text", icon: "👤" },
  { name: "phone", label: "Phone Number", required: false, type: "text", icon: "📞" },
  { name: "license_number", label: "License Number", required: false, type: "text", icon: "🪪" },
  { name: "license_expiry", label: "License Expiry Date", required: false, type: "date", icon: "📅" },
];

const VEHICLE_FIELDS = [
  { name: "vehicle_number", label: "Vehicle Number", required: true, type: "text", icon: "🚛" },
  { name: "vehicle_type", label: "Vehicle Type", required: false, type: "text", icon: "🏷️" },
  { name: "capacity_kg", label: "Capacity (kg)", required: false, type: "number", icon: "⚖️" },
  { name: "color", label: "Color", required: false, type: "text", icon: "🎨" },
  { name: "fitness_expiry", label: "Fitness Expiry Date", required: false, type: "date", icon: "📅" },
];

// Styled Field Component
function StyledField({
  field,
  value,
  onChange,
}: {
  field: { name: string; label: string; required: boolean; type: string; icon: string };
  value: string | number | undefined;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  const [focused, setFocused] = useState(false);
  const hasValue = value !== undefined && value !== "" && value !== null;
  const isFloating = focused || hasValue || field.type === "date";

  return (
    <div
      style={{
        position: "relative",
        marginBottom: "0px",
      }}
    >
      {/* Icon */}
      <span
        style={{
          position: "absolute",
          left: "14px",
          top: "50%",
          transform: "translateY(-50%)",
          fontSize: "15px",
          zIndex: 2,
          pointerEvents: "none",
          opacity: 0.75,
          lineHeight: 1,
        }}
      >
        {field.icon}
      </span>

      {/* Floating Label */}
      <label
        htmlFor={field.name}
        style={{
          position: "absolute",
          left: "44px",
          top: isFloating ? "8px" : "50%",
          transform: isFloating ? "translateY(0) scale(0.78)" : "translateY(-50%) scale(1)",
          transformOrigin: "left center",
          fontSize: "14px",
          fontWeight: 500,
          color: focused ? "#6366f1" : isFloating ? "#64748b" : "#94a3b8",
          pointerEvents: "none",
          transition: "all 0.18s cubic-bezier(.4,0,.2,1)",
          zIndex: 2,
          letterSpacing: "0.01em",
          whiteSpace: "nowrap",
        }}
      >
        {field.label}
        {field.required && (
          <span style={{ color: "#f43f5e", marginLeft: "3px" }}>*</span>
        )}
      </label>

      {/* Input */}
      <input
        id={field.name}
        name={field.name}
        type={field.type}
        required={field.required}
        value={
          field.type === "date"
            ? value
              ? stripDateOnly(String(value))
              : ""
            : value ?? ""
        }
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          width: "100%",
          padding: "22px 14px 8px 44px",
          fontSize: "14px",
          fontWeight: 500,
          color: "#0f172a",
          background: focused ? "#f8faff" : "#f8fafc",
          border: focused
            ? "1.5px solid #6366f1"
            : "1.5px solid #e2e8f0",
          borderRadius: "12px",
          outline: "none",
          boxSizing: "border-box",
          transition: "all 0.18s ease",
          boxShadow: focused
            ? "0 0 0 3px rgba(99,102,241,0.1)"
            : "0 1px 2px rgba(0,0,0,0.04)",
          letterSpacing: "0.02em",
        }}
      />
    </div>
  );
}

// Modal Form
function ModalForm({
  show,
  type,
  form,
  onClose,
  onChange,
  onSubmit,
  onDelete,
  submitting,
  delLoading,
  message,
  isEdit,
  title,
  subtitle,
}: {
  show: boolean;
  type: "driver" | "vehicle" | null;
  form: any;
  onClose: () => void;
  onChange: (e: React.ChangeEvent<any>) => void;
  onSubmit: (e: React.FormEvent) => void;
  onDelete?: () => void;
  submitting: boolean;
  delLoading: boolean;
  message: string | null;
  isEdit: boolean;
  title?: string;
  subtitle?: string;
}) {
  if (!show || !type) return null;
  const fields = type === "driver" ? DRIVER_FIELDS : VEHICLE_FIELDS;
  const displayTitle =
    title ||
    (isEdit
      ? `Edit ${type[0].toUpperCase() + type.slice(1)}`
      : `Add ${type[0].toUpperCase() + type.slice(1)}`);

  const isSuccess = message && /success|deleted/i.test(message);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(15,23,42,0.45)",
        backdropFilter: "blur(4px)",
        padding: "16px",
      }}
    >
      <div
        style={{
          background: "#ffffff",
          borderRadius: "20px",
          boxShadow:
            "0 24px 64px -12px rgba(0,0,0,0.22), 0 0 0 1px rgba(0,0,0,0.04)",
          width: "100%",
          maxWidth: "480px",
          position: "relative",
          overflow: "hidden",
          animation: "modalIn 0.22s cubic-bezier(.4,0,.2,1)",
        }}
      >
        {/* Colored top bar */}
        <div
          style={{
            height: "4px",
            background:
              type === "driver"
                ? "linear-gradient(90deg, #6366f1, #818cf8)"
                : "linear-gradient(90deg, #0ea5e9, #38bdf8)",
            borderRadius: "20px 20px 0 0",
          }}
        />

        {/* Header */}
        <div
          style={{
            padding: "24px 28px 0 28px",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}
        >
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginBottom: "2px",
              }}
            >
              <span
                style={{
                  fontSize: "22px",
                  background:
                    type === "driver"
                      ? "linear-gradient(135deg,#eef2ff,#e0e7ff)"
                      : "linear-gradient(135deg,#e0f2fe,#bae6fd)",
                  borderRadius: "10px",
                  width: "38px",
                  height: "38px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {type === "driver" ? "👤" : "🚛"}
              </span>
              <div>
                <h2
                  style={{
                    fontSize: "17px",
                    fontWeight: 700,
                    color: "#0f172a",
                    letterSpacing: "-0.02em",
                    margin: 0,
                    lineHeight: 1.2,
                  }}
                >
                  {displayTitle}
                </h2>
                {subtitle && (
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#94a3b8",
                      margin: "2px 0 0",
                      fontWeight: 500,
                    }}
                  >
                    {subtitle}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Close button */}
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "#f1f5f9",
              border: "none",
              borderRadius: "8px",
              width: "32px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              color: "#64748b",
              fontSize: "16px",
              flexShrink: 0,
              transition: "background 0.15s",
            }}
            onMouseEnter={(e) =>
              ((e.target as HTMLElement).style.background = "#e2e8f0")
            }
            onMouseLeave={(e) =>
              ((e.target as HTMLElement).style.background = "#f1f5f9")
            }
            title="Close"
            aria-label="Close Modal"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: "20px 28px 28px 28px" }}>
          {!form ? (
            <div
              style={{
                padding: "48px 0",
                textAlign: "center",
                color: "#94a3b8",
              }}
            >
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  border: "3px solid #e2e8f0",
                  borderTop: "3px solid #6366f1",
                  borderRadius: "50%",
                  animation: "spin 0.8s linear infinite",
                  margin: "0 auto 12px",
                }}
              />
              <span style={{ fontSize: "14px" }}>Loading…</span>
            </div>
          ) : (
            <form onSubmit={onSubmit}>
              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                {fields.map((field) => (
                  <StyledField
                    key={field.name}
                    field={field}
                    value={form[field.name]}
                    onChange={onChange}
                  />
                ))}
              </div>

              {/* Divider */}
              <div
                style={{
                  height: "1px",
                  background: "#f1f5f9",
                  margin: "20px 0",
                }}
              />

              {/* Actions */}
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <button
                  type="submit"
                  disabled={submitting}
                  style={{
                    flex: 1,
                    padding: "11px 20px",
                    background: submitting
                      ? "#a5b4fc"
                      : "linear-gradient(135deg, #6366f1, #818cf8)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "10px",
                    fontSize: "14px",
                    fontWeight: 600,
                    cursor: submitting ? "not-allowed" : "pointer",
                    letterSpacing: "0.02em",
                    transition: "all 0.15s",
                    boxShadow: submitting
                      ? "none"
                      : "0 4px 12px rgba(99,102,241,0.3)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                  }}
                >
                  {submitting ? (
                    <>
                      <span
                        style={{
                          width: "14px",
                          height: "14px",
                          border: "2px solid rgba(255,255,255,0.4)",
                          borderTop: "2px solid #fff",
                          borderRadius: "50%",
                          animation: "spin 0.7s linear infinite",
                          display: "inline-block",
                        }}
                      />
                      Saving…
                    </>
                  ) : (
                    <>{isEdit ? "Save Changes" : `Add ${type[0].toUpperCase() + type.slice(1)}`}</>
                  )}
                </button>

                {isEdit && onDelete && (
                  <button
                    type="button"
                    onClick={onDelete}
                    disabled={delLoading}
                    style={{
                      padding: "11px 16px",
                      background: delLoading ? "#fca5a5" : "#fff0f0",
                      color: delLoading ? "#fff" : "#ef4444",
                      border: "1.5px solid #fecaca",
                      borderRadius: "10px",
                      fontSize: "13px",
                      fontWeight: 600,
                      cursor: delLoading ? "not-allowed" : "pointer",
                      transition: "all 0.15s",
                      whiteSpace: "nowrap",
                    }}
                    onMouseEnter={(e) => {
                      if (!delLoading) {
                        (e.currentTarget as HTMLElement).style.background = "#fef2f2";
                        (e.currentTarget as HTMLElement).style.borderColor = "#ef4444";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!delLoading) {
                        (e.currentTarget as HTMLElement).style.background = "#fff0f0";
                        (e.currentTarget as HTMLElement).style.borderColor = "#fecaca";
                      }
                    }}
                  >
                    {delLoading ? "Deleting…" : "🗑 Delete"}
                  </button>
                )}
              </div>

              {/* Message */}
              {message && (
                <div
                  style={{
                    marginTop: "14px",
                    padding: "10px 14px",
                    borderRadius: "9px",
                    fontSize: "13px",
                    fontWeight: 500,
                    background: isSuccess ? "#f0fdf4" : "#fff1f2",
                    color: isSuccess ? "#16a34a" : "#e11d48",
                    border: `1px solid ${isSuccess ? "#bbf7d0" : "#fecdd3"}`,
                    display: "flex",
                    alignItems: "center",
                    gap: "7px",
                  }}
                >
                  <span>{isSuccess ? "✓" : "⚠"}</span>
                  {message}
                </div>
              )}
            </form>
          )}
        </div>

        {/* Keyframe styles */}
        <style>{`
          @keyframes modalIn {
            from { opacity: 0; transform: scale(0.96) translateY(8px); }
            to   { opacity: 1; transform: scale(1) translateY(0); }
          }
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
}

const AdminTransporterPage: React.FC<Props> = ({ mode }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const params = useParams();

  // --- List state ---
  const [allDrivers, setAllDrivers] = useState<any[]>([]);
  const [allVehicles, setAllVehicles] = useState<any[]>([]);
  const [tab, setTab] = useState<"vehicles" | "drivers">("vehicles");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  // --- Modal state ---
  const [modalMode, setModalMode] = useState<"add" | "edit" | null>(null);
  const [modalType, setModalType] = useState<"driver" | "vehicle" | null>(null);
  const [modalForm, setModalForm] = useState<any>(null);
  const [modalSubmitting, setModalSubmitting] = useState(false);
  const [modalDelLoading, setModalDelLoading] = useState(false);
  const [modalMessage, setModalMessage] = useState<string | null>(null);
  const [modalId, setModalId] = useState<string | null>(null);

  const openAddModal = (type: "driver" | "vehicle") => {
    setModalMode("add");
    setModalType(type);
    setModalForm({});
    setModalSubmitting(false);
    setModalDelLoading(false);
    setModalMessage(null);
    setModalId(null);
  };

  const openEditModal = (type: "driver" | "vehicle", recordId: number) => {
    setModalMode("edit");
    setModalType(type);
    setModalSubmitting(false);
    setModalDelLoading(false);
    setModalMessage(null);
    setModalId(String(recordId));
    setModalForm(null);
    setLoading(true);
    const url =
      type === "driver"
        ? `${apiUrl}/auth/drivers/${recordId}`
        : `${apiUrl}/auth/vehicles/${recordId}`;
    fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error("Failed to fetch details");
        return r.json();
      })
      .then((data) => setModalForm(data))
      .catch((e) => setModalMessage(e?.message || "Failed to fetch details"))
      .finally(() => setLoading(false));
  };

  const closeModal = () => {
    setModalMode(null);
    setModalType(null);
    setModalForm(null);
    setModalMessage(null);
    setModalSubmitting(false);
    setModalDelLoading(false);
    setModalId(null);
  };

  const handleEditDriver = (driver: any) => openEditModal("driver", driver.id);
  const handleEditVehicle = (vehicle: any) => openEditModal("vehicle", vehicle.id);
  const handleAddDriver = () => openAddModal("driver");
  const handleAddVehicle = () => openAddModal("vehicle");

  const handleModalChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setModalForm((old: any) => ({ ...old, [e.target.name]: e.target.value }));
  };

  const handleModalSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!modalForm || !modalType || !apiUrl) return;
    setModalSubmitting(true);
    setModalMessage(null);
    try {
      let url = "";
      let method: "POST" | "PUT" = "POST";
      let res: Response;
      let payload = prepareUpdatePayload(modalForm, modalType);
      let isEdit = modalMode === "edit" && modalId;

      if (modalType === "driver") {
        url = isEdit ? `${apiUrl}/auth/drivers/${modalId}` : `${apiUrl}/auth/drivers`;
        if (isEdit) method = "PUT";
      } else {
        url = isEdit ? `${apiUrl}/auth/vehicles/${modalId}` : `${apiUrl}/auth/vehicles`;
        if (isEdit) method = "PUT";
      }

      res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error(isEdit ? "Failed to update" : "Failed to add");

      const resultData = await res.json();

      if (!isEdit && (mode === "add" || mode === "list")) {
        window.location.reload();
        return;
      }
      if (isEdit && mode === "edit") {
        window.location.reload();
        return;
      }

      if (modalType === "driver") {
        if (isEdit) {
          setAllDrivers((old) => old.map((d) => String(d.id) === modalId ? { ...d, ...payload } : d));
          setModalMessage("Saved successfully!");
        } else {
          setAllDrivers((old) => [...old, resultData]);
          setModalMessage("Driver added successfully!");
        }
      } else {
        if (isEdit) {
          setAllVehicles((old) => old.map((v) => String(v.id) === modalId ? { ...v, ...payload } : v));
          setModalMessage("Saved successfully!");
        } else {
          setAllVehicles((old) => [...old, resultData]);
          setModalMessage("Vehicle added successfully!");
        }
      }
      setTimeout(closeModal, 700);
    } catch (e: any) {
      setModalMessage(e?.message || (modalMode === "edit" ? "Update failed" : "Add failed"));
    } finally {
      setModalSubmitting(false);
    }
  };

  const handleModalDelete = async () => {
    if (!modalType || !modalId || !apiUrl) return;
    if (!window.confirm(`Are you sure you want to delete this ${modalType}?`)) return;
    setModalDelLoading(true);
    setModalMessage(null);
    try {
      let url =
        modalType === "driver"
          ? `${apiUrl}/auth/drivers/${modalId}`
          : `${apiUrl}/auth/vehicles/${modalId}`;
      let res = await fetch(url, { method: "DELETE" });
      if (!res.ok) throw new Error(`Failed to delete`);
      if (modalType === "driver") {
        setAllDrivers((old) => old.filter((d) => String(d.id) !== modalId));
      } else {
        setAllVehicles((old) => old.filter((v) => String(v.id) !== modalId));
      }
      setModalMessage(`${modalType[0].toUpperCase() + modalType.slice(1)} deleted`);
      setTimeout(closeModal, 500);
    } catch (e: any) {
      setModalMessage(e?.message || "Failed to delete");
    } finally {
      setModalDelLoading(false);
    }
  };

  const handleDeleteDriver = async (driverId: number) => {
    if (!apiUrl) return;
    if (!window.confirm("Are you sure you want to delete this driver?")) return;
    setLoading(true);
    setMessage(null);
    try {
      const res = await fetch(`${apiUrl}/auth/drivers/${driverId}`, { method: "DELETE" });
      if (!res.ok) throw new Error("Failed to delete driver");
      setAllDrivers((old) => old.filter((d) => d.id !== driverId));
      setMessage("Driver deleted");
    } catch (e: any) {
      setMessage(e?.message || "Failed to delete driver");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteVehicle = async (vehicleId: number) => {
    if (!apiUrl) return;
    if (!window.confirm("Are you sure you want to delete this vehicle?")) return;
    setLoading(true);
    setMessage(null);
    try {
      const res = await fetch(`${apiUrl}/auth/vehicles/${vehicleId}`, { method: "DELETE" });
      if (!res.ok) throw new Error("Failed to delete vehicle");
      setAllVehicles((old) => old.filter((v) => v.id !== vehicleId));
      setMessage("Vehicle deleted");
    } catch (e: any) {
      setMessage(e?.message || "Failed to delete vehicle");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!apiUrl || mode !== "list") return;
    setLoading(true);
    Promise.all([
      fetch(`${apiUrl}/auth/drivers`).then((r) => r.json()).catch(() => []),
      fetch(`${apiUrl}/auth/vehicles`).then((r) => r.json()).catch(() => []),
    ]).then(([drivers, vehicles]) => {
      setAllDrivers(Array.isArray(drivers) ? drivers : []);
      setAllVehicles(Array.isArray(vehicles) ? vehicles : []);
    }).finally(() => setLoading(false));
  }, [mode, apiUrl]);

  const path = window.location.pathname;
  const isDriver = path.includes("/admin/drivers/edit/");
  const isVehicle = path.includes("/admin/vehicles/edit/");
  const id = params.id || (path.match(/\/edit\/(\d+)/) ? path.match(/\/edit\/(\d+)/)![1] : null);

  const [routeEditForm, setRouteEditForm] = useState<any>(null);
  const [routeEditLoading, setRouteEditLoading] = useState(false);
  const [routeEditMessage, setRouteEditMessage] = useState<string | null>(null);
  const [showRouteEditModal, setShowRouteEditModal] = useState(false);
  const [routeEditSubmitting, setRouteEditSubmitting] = useState(false);
  const [routeEditDelLoading, setRouteEditDelLoading] = useState(false);

  useEffect(() => {
    if (mode !== "edit" || !apiUrl || !id) return;
    setShowRouteEditModal(true);
    setRouteEditLoading(true);
    setRouteEditForm(null);
    setRouteEditMessage(null);
    let fetchUrl: null | string = null;
    if (isDriver) fetchUrl = `${apiUrl}/auth/drivers/${id}`;
    else if (isVehicle) fetchUrl = `${apiUrl}/auth/vehicles/${id}`;
    if (!fetchUrl) {
      setRouteEditLoading(false);
      setRouteEditMessage("No fetch URL available");
      return;
    }
    fetch(fetchUrl)
      .then((r) => {
        if (!r.ok) throw new Error("Failed to fetch details");
        return r.json();
      })
      .then((data) => setRouteEditForm(data))
      .catch((e) => setRouteEditMessage(e?.message || "Failed to fetch details"))
      .finally(() => setRouteEditLoading(false));
    // eslint-disable-next-line
  }, [mode, apiUrl, id, isDriver, isVehicle]);

  const handleRouteEditChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setRouteEditForm((old: any) => ({ ...old, [e.target.name]: e.target.value }));
  };

  const handleRouteEditSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!routeEditForm || !id || !apiUrl) return;
    setRouteEditSubmitting(true);
    setRouteEditMessage(null);
    try {
      let payload: any = routeEditForm;
      let res: Response;
      if (isDriver) {
        payload = prepareUpdatePayload(routeEditForm, "driver");
        res = await fetch(`${apiUrl}/auth/drivers/${id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      } else if (isVehicle) {
        payload = prepareUpdatePayload(routeEditForm, "vehicle");
        res = await fetch(`${apiUrl}/auth/vehicles/${id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      } else throw new Error("Unknown edit type");
      if (!res.ok) throw new Error("Failed to update");
      window.location.reload();
      return;
    } catch (e: any) {
      setRouteEditMessage(e?.message || "Update failed");
    } finally {
      setRouteEditSubmitting(false);
    }
  };

  const handleRouteEditDelete = async () => {
    if (!id || !apiUrl) return;
    if (!window.confirm(`Are you sure you want to delete this ${isDriver ? "driver" : "vehicle"}?`)) return;
    setRouteEditDelLoading(true);
    setRouteEditMessage(null);
    try {
      let res: Response;
      if (isDriver) res = await fetch(`${apiUrl}/auth/drivers/${id}`, { method: "DELETE" });
      else if (isVehicle) res = await fetch(`${apiUrl}/auth/vehicles/${id}`, { method: "DELETE" });
      else throw new Error("Unknown delete type");
      if (!res.ok) throw new Error("Failed to delete");
      setRouteEditMessage(`${isDriver ? "Driver" : "Vehicle"} deleted`);
      setTimeout(() => {
        setShowRouteEditModal(false);
        navigate("/admin/transporters?tab=" + (isDriver ? "drivers" : "vehicles"));
      }, 300);
    } catch (e: any) {
      setRouteEditMessage(e?.message || "Failed to delete");
    } finally {
      setRouteEditDelLoading(false);
    }
  };

  const showPerfectModal = !!modalMode && modalType != null;

  if (mode === "edit") {
    return showRouteEditModal ? (
      <ModalForm
        show={showRouteEditModal}
        type={isDriver ? "driver" : "vehicle"}
        form={routeEditForm}
        onClose={() => { setShowRouteEditModal(false); navigate(-1); }}
        onChange={handleRouteEditChange}
        onSubmit={handleRouteEditSubmit}
        onDelete={handleRouteEditDelete}
        submitting={routeEditSubmitting}
        delLoading={routeEditDelLoading}
        message={routeEditMessage}
        isEdit={true}
        title={isDriver ? "Edit Driver" : "Edit Vehicle"}
        subtitle={isDriver ? `Driver ID: ${id}` : `Vehicle ID: ${id}`}
      />
    ) : null;
  }

  if (mode === "list") {
    return (
      <div className="p-4 md:p-6">
        {showPerfectModal && (
          <ModalForm
            show={showPerfectModal}
            type={modalType}
            form={modalForm}
            onClose={closeModal}
            onChange={handleModalChange}
            onSubmit={handleModalSubmit}
            onDelete={modalMode === "edit" ? handleModalDelete : undefined}
            submitting={modalSubmitting}
            delLoading={modalDelLoading}
            message={modalMessage}
            isEdit={modalMode === "edit"}
          />
        )}

        <Panel title="All Vehicles & Drivers" subtitle="">
          <div className="mb-3 flex gap-4 items-center">
            <button
              className={`px-4 py-2 text-sm font-semibold border-b-2 ${
                tab === "vehicles" ? "border-indigo-600 text-indigo-700" : "border-transparent text-slate-700"
              }`}
              onClick={() => setTab("vehicles")}
              type="button"
            >
              Vehicles ({allVehicles.length})
            </button>
            <button
              className={`px-4 py-2 text-sm font-semibold border-b-2 ${
                tab === "drivers" ? "border-indigo-600 text-indigo-700" : "border-transparent text-slate-700"
              }`}
              onClick={() => setTab("drivers")}
              type="button"
            >
              Drivers ({allDrivers.length})
            </button>
            <div className="flex-1" />
            {tab === "vehicles" ? (
              <button type="button" onClick={handleAddVehicle} className="px-3 py-2 rounded-lg text-sm bg-slate-900 text-white">
                Add Vehicle
              </button>
            ) : (
              <button type="button" onClick={handleAddDriver} className="px-3 py-2 rounded-lg text-sm bg-slate-900 text-white">
                Add Driver
              </button>
            )}
          </div>

          {tab === "vehicles" ? (
            <div className="grid gap-1 mt-4">
              <div className="grid grid-cols-5 font-semibold text-xs text-slate-500 py-2">
                <span>Vehicle No.</span>
                <span></span>
                <span>Actions</span>
              </div>
              {allVehicles.length === 0 && <p className="text-xs text-slate-500 px-2">No vehicles</p>}
              {allVehicles.map((vehicle) => (
                <div key={vehicle.id} className="grid grid-cols-5 items-center border rounded p-2 bg-slate-50">
                  <span>{vehicle.vehicle_number ?? "-"}</span>
                  <span></span>
                  <span className="flex gap-2">
                    <button type="button" onClick={() => handleEditVehicle(vehicle)} className="px-2 py-1 text-xs rounded-md bg-yellow-100 text-yellow-700">Edit</button>
                    <button type="button" onClick={() => handleDeleteVehicle(vehicle.id)} className="px-2 py-1 text-xs rounded-md bg-red-100 text-red-700">Delete</button>
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <div className="grid gap-1 mt-4">
              <div className="grid grid-cols-6 font-semibold text-xs text-slate-500 py-2">
                <span>Driver Name</span>
                <span>Driver Number</span>
                <span></span>
                <span>Actions</span>
              </div>
              {allDrivers.length === 0 && <p className="text-xs text-slate-500 px-2">No drivers</p>}
              {allDrivers.map((driver) => (
                <div key={driver.id} className="grid grid-cols-6 items-center border rounded p-2 bg-slate-50">
                  <span>{driver.name ?? "-"}</span>
                  <span>{driver.phone ?? "-"}</span>
                  <span></span>
                  <span className="flex gap-2">
                    <button type="button" onClick={() => handleEditDriver(driver)} className="px-2 py-1 text-xs rounded-md bg-yellow-100 text-yellow-700">Edit</button>
                    <button type="button" onClick={() => handleDeleteDriver(driver.id)} className="px-2 py-1 text-xs rounded-md bg-red-100 text-red-700">Delete</button>
                  </span>
                </div>
              ))}
            </div>
          )}
          {message && <div className="mt-2 text-xs text-red-500">{message}</div>}
        </Panel>
      </div>
    );
  }

  return null;
};

export default AdminTransporterPage;